import AzPanel from './az-panel/index.js';
import AzLoading from './az-loading/index.js';
import AzLink from './az-link/index.js';
import AzIssue from './az-issue/index.js';

import './styles/index.scss';

const components = [AzPanel, AzLoading, AzLink, AzIssue];


const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: '1.0.0',
  install,
  AzPanel,
  AzLoading,
  AzLink,
  AzIssue
}

/*
* TODO: 1.颜色可定制,css需要单独打包
*/